"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var CONSUME_CUSTOMER_NOTIFICATION_MUTATION = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation ConsumeCustomerNotification($consumeCustomerNotificationId: ID!, $appId: AppId) {\n    consumeCustomerNotification(id: $consumeCustomerNotificationId, appId: $appId)\n  }\n"], ["\n  mutation ConsumeCustomerNotification($consumeCustomerNotificationId: ID!, $appId: AppId) {\n    consumeCustomerNotification(id: $consumeCustomerNotificationId, appId: $appId)\n  }\n"])));
exports.default = CONSUME_CUSTOMER_NOTIFICATION_MUTATION;
var templateObject_1;
//# sourceMappingURL=consumeCustomerNotificationMutation.js.map